<br><br>
<app-gestiones-header-preca [buttonselected]=2 [participante]="participante" [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="table-data">
            <div class="cabecera-gris">
                <h1>FLUJO DE EVALUACION</h1>
            </div>
            <div class="row" style="width: 90%;margin: 10px auto 10px auto;">
                <div class="col-md-2" style="padding: 0 5px 0 0;">
                    <div class="cabecera-outline" style="width: 100%;margin: 10px auto 0 auto;">
                        <h1>RESULTADO</h1>
                    </div>
                </div>
                <div class="col-md-7" style="padding: 0 5px 0 5px;">
                    <div class="cabecera-outline" style="width: 100%;margin: 10px auto 0 auto;">
                        <h1>NOMBRE</h1>
                    </div>
                </div>
                <div class="col-md-3" style="padding: 0 0 0 5px;">
                    <div class="cabecera-outline" style="width: 100%;margin: 10px auto 0 auto;">
                        <h1>TIPO</h1>
                    </div>
                </div>
            </div>
            <div class="cabecera-outline">
                <h1>INICIO</h1>
            </div>
            <div class="table4" style="width: 90%;margin: 0 auto 0 auto;">
                <table class="table table-borderless">
                  <tbody *ngIf="gestionSeleccionada.version!='V2'">
                    <tr *ngFor="let item of listflujo">
                      <td>
                          <img *ngIf="item.tipo=='A'" src="../../assets/icons/Botones Politicas Verde.png" height="15px">
                          <img *ngIf="item.tipo=='R'" src="../../assets/icons/Botones Politicas rojo.png" height="15px">
                          <img *ngIf="item.tipo=='SD'" src="../../assets/icons/Boton Amarillo.png" height="15px">
                        </td>
                      <td>{{item.nombre}}</td>
                      <td>Política</td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="gestionSeleccionada.version=='V2'">
                    <tr *ngFor="let item of listflujoV2">
                      <td>
                          <img *ngIf="item.reglaDecision=='APROBADO'" src="../../assets/icons/Botones Politicas Verde.png" height="15px">
                          <img *ngIf="item.reglaDecision=='RECHAZAR'" src="../../assets/icons/Botones Politicas rojo.png" height="15px">
                          <img *ngIf="item.reglaDecision=='SIN DECISION'" src="../../assets/icons/Boton Amarillo.png" height="15px">
                        </td>
                      <td>{{item.reglaNombre}}</td>
                      <td>{{item.reglaTipoPolitica=='Politica'?'Política':'Regla Administrativa'}}</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="cabecera-outline">
                <h1>FIN</h1>
            </div>
        </div>
    </div>
</div>
